import React from "react";
import Form from "../Components/Form/HelpForm";
import "./Help.scss";
import HeroImg from "../Components/Layouts/HeroImg";
import { FaEnvelope, FaPhone, FaLocationArrow } from "react-icons/fa";
import GoogleMap from "../Components/Map/Map";

const contacts = [
  {
    title: "Phone",
    icon: <FaPhone />,
    details: [
      { label: "Toll-Free", value: "0803 - 080 - 3081", isPhone:true },
      { label: "Fax", value: "0803 - 080 - 3082", isPhone:true },
    ],
  },
  {
    title: "Email",
    icon: <FaEnvelope />,
    details: [
      { label: "Support", value: "support@example.com", isEmail: true },
      { label: "Sales", value: "sales@example.com", isEmail: true },
    ],
  },
  {
    title: "Address",
    icon: <FaLocationArrow />,
    details: [
      { label: "Campus", value: "UCER" },
      { label: "Branch", value: "Naini, Prayagraj" },
    ],
  },
];

const Help = () => {
  return (
    <>
      <HeroImg
        heading="Having queries?"
        text="We are here to help you. Feel free to contact us."
      />
        <GoogleMap />
      <div className="help">
        <div className="help_left">
          <div className="contact-cards">
            {contacts.map((contact, index) => (
              <div className="contact-card" key={index}>
                <div className="icon-box">{contact.icon}</div>
                <div className="contact-info">
                  <h3 className="contact-title">{contact.title}</h3>
                  {contact.details.map((detail, i) => (
                    <p key={i}>
                      <strong>{detail.label}:</strong>{" "}
                      {detail.isEmail ? (
                        <a
                          href={`mailto:${detail.value}`}
                          className="email-link"
                        >
                          {detail.value}
                        </a>
                      ) : detail.isPhone ? (
                        <a href={`tel:${detail.value}`} className="phone-link">
                          {detail.value}
                        </a>
                      ):(
                        detail.value
                      )}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="help_right">
          <Form />
        </div>
      </div>
    </>
  );
};

export default Help;
